export class ShareholderFundPositionModel {
  positionDate: string = null;
  shareholderSourceId: string = null;
  positions: ShareholderFundPositionFundsPositionsModel[] = null;
}

export class ShareholderFundPositionFundsPositionsModel {
  fundSourceId: string = null;
  fundName: string = null;
  quotaAmount: number = null;
  applicationValue: number = null;
  correctedValue: number = null;
  iofValue: number = null;
  taxValue: number = null;
  redemptionValue: number = null;
  incomeValue: number = null;
  invoices: ShareholderFundPositionFundInvoiceModel[] = null;
}

export class ShareholderFundPositionFundInvoiceModel {
  invoiceId: string = null;
  settlementStockDetainer: string = null;
  applicationDate: string = null;
  settlementDate: string = null;
  quotaAmount: number = null;
  applicationValue: number = null;
  correctedValue: number = null;
  iofValue: number = null;
  iofAliquot: number = null;
  iofElapsedDays: number = null;
  taxValue: number = null;
  taxAliquot: number = null;
  taxElapsedDays: number = null;
  redemptionValue: number = null;
  incomeValue: number = null;
  resultPercentage: number = null;
  iofExemptionDate: string = null;

  fundSourceId: string = null;
}
